(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_accordion-row"] && !Shopify.designMode) return;
  try {
    class AccordionReadMore {
    static init() {
      document.querySelectorAll('.details--read-more').forEach((details) => {
        if (details.dataset.readMoreInit) return;
        details.dataset.readMoreInit = 'true';
        new AccordionReadMore(details);
      });
    }

    constructor(details) {
      this.details = details;
      this.text = details.dataset.readMoreText || 'Read more';

      if (details.open) {
        // Already open: set up after the browser has applied styles
        requestAnimationFrame(() => this.setup());
      } else {
        // Closed: set up the first time the user opens it
        details.addEventListener('toggle', () => {
          if (details.open) requestAnimationFrame(() => this.setup());
        }, { once: true });
      }
    }

    setup() {
      const textBlock = this.details.querySelector('.text-block');
      if (!textBlock || textBlock.dataset.readMoreBtn) return;
      textBlock.dataset.readMoreBtn = 'true';

      // CSS already clamps the text block via max-height.
      // Only show the button if the content actually overflows.
      if (textBlock.scrollHeight <= textBlock.clientHeight + 1) return;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'accordion-read-more-btn';
      btn.textContent = this.text;
      btn.addEventListener('click', () => {
        this.details.classList.remove('details--read-more');
        btn.remove();
      });
      textBlock.after(btn);
    }
  }

  function initAccordionReadMore() {
    AccordionReadMore.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordionReadMore);
  } else {
    initAccordionReadMore();
  }

  // Re-init when Shopify editor reloads a block
  document.addEventListener('shopify:block:load', initAccordionReadMore);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    (function () {
    const starts = new Map();

    document.addEventListener('pointerdown', function (e) {
      if (e.target.closest('slideshow-slide[data-slide-link]')) {
        starts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      }
    });

    document.addEventListener('pointerup', function (e) {
      const start = starts.get(e.pointerId);
      starts.delete(e.pointerId);
      if (!start) return;

      // Ignore if pointer travelled more than 10px (drag)
      if (Math.abs(e.clientX - start.x) > 10 || Math.abs(e.clientY - start.y) > 10) return;

      const slide = e.target.closest('slideshow-slide[data-slide-link]');
      if (!slide) return;

      // Only navigate when this slide is the active one
      if (slide.getAttribute('aria-hidden') === 'true') return;

      // Let interactive children handle their own clicks
      if (e.target.closest('a, button, [role="button"], input, select, video')) return;

      const url = slide.dataset.slideLink;
      if (!url) return;

      if (slide.hasAttribute('data-slide-link-new-tab')) {
        window.open(url, '_blank', 'noopener,noreferrer');
      } else {
        window.location.href = url;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    /*
    Multi-column accordions: a CSS grid shares one height per grid row, so opening a row also pushes
    the row beside it down. Splitting the rows into independent columns on desktop lets each column
    grow on its own. Rows are dealt out round-robin to keep the reading order of the single column.
    Without JS (or if the rows are not direct children) the CSS grid fallback is used.
  */
  (() => {
    const desktop = window.matchMedia('(min-width: 750px)');

    function rowsOf(accordion) {
      return [...accordion.children].filter((el) => el.tagName === 'ACCORDION-CUSTOM');
    }

    function split(accordion) {
      if (accordion.classList.contains('accordion--split')) return;

      const count = Number(accordion.dataset.columns) || 1;
      const rows = rowsOf(accordion);
      if (count < 2 || rows.length === 0) return;

      const columns = Array.from({ length: count }, () => {
        const column = document.createElement('div');
        column.className = 'accordion__column';
        return column;
      });

      rows.forEach((row, index) => columns[index % count].append(row));
      accordion.append(...columns);
      accordion.classList.add('accordion--split');
    }

    function merge(accordion) {
      if (!accordion.classList.contains('accordion--split')) return;

      const columns = [...accordion.querySelectorAll(':scope > .accordion__column')];
      const lists = columns.map((column) => [...column.children]);
      const longest = Math.max(...lists.map((list) => list.length));

      for (let index = 0; index < longest; index++) {
        lists.forEach((list) => list[index] && accordion.append(list[index]));
      }

      columns.forEach((column) => column.remove());
      accordion.classList.remove('accordion--split');
    }

    function layout() {
      document.querySelectorAll('.accordion--grid').forEach((accordion) => {
        if (desktop.matches) split(accordion);
        else merge(accordion);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', layout);
    } else {
      layout();
    }

    desktop.addEventListener('change', layout);

    // Re-run when the Shopify editor reloads a section or block
    document.addEventListener('shopify:section:load', layout);
    document.addEventListener('shopify:block:load', layout);
  })();
  } catch(e) { console.error(e); }
})();

})();
